
import { UserInfo } from "@/models/dossier/user-info";
import { View } from "@/models/view";
import { AuthService, DossierService, ViewService } from "@/services";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
export default Vue.extend({
	data(){
		return {
			savedShares: [] as number[],
			shareUsers: [] as number[],
			unshareUsers: [] as number[],
			DossierService,
		};
	},
	props: {
		view: {
			type: Object as ()=>View,
			required: true
		}
	},
	computed: {
		users():UserInfo[] {
			return this.DossierService.users.filter(v=>v.ID != AuthService.wfUser.ID);
		},
		title():TranslateResult {
			return this.$ct("share-view", {name: this.view.Name});
		}
	},
	watch: {
		view: {
			immediate: true,
			async handler(){
				await this.fetchSettings();
			}
		}
	},
	methods: {
		async fetchSettings(){
			this.savedShares = await ViewService.getShares(this.view);
			this.unshareUsers = [];
			this.shareUsers = [];
			for (let share of this.savedShares){
				if (!this.users.find(u=>u.ID == share)) {
					this.unshareUsers.push(share);
				}
			}
		},
		isUserShared(userId:number):boolean{
			if (this.shareUsers.indexOf(userId) != -1) {
				return true;
			}
			if (this.unshareUsers.indexOf(userId) != -1){
				return false;
			}
			if (this.savedShares.indexOf(userId) != -1){
				return true;
			}
			return false;
		},
		toggleUser(userId:number, val:boolean) {
			if (val){
				this.setUser(userId);
			}else{
				this.resetUser(userId);
			}
		},
		setUser(userId:number){
			let i = this.unshareUsers.indexOf(userId);
			if (i != -1){
				this.unshareUsers.splice(i,1);
			}
			if (this.shareUsers.indexOf(userId) != -1) {
				return;
			}
			if (this.savedShares.indexOf(userId) != -1){
				return;
			}
			this.shareUsers.push(userId);
		},
		resetUser(userId:number){
			let i = this.shareUsers.indexOf(userId);
			if (i != -1){
				this.shareUsers.splice(i, 1);
			}
			if (this.unshareUsers.indexOf(i) != -1){
				return;
			}
			if (this.savedShares.indexOf(userId) == -1){
				return;
			}
			this.unshareUsers.push(userId);
		},
		async save(){
			await ViewService.setShares(this.view, this.shareUsers, this.unshareUsers);
			this.close();
		},
		close(){
			this.$emit("close");
		}
	},
	async created(){
		await this.DossierService.getUsers();
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}

});
